import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { Toolbar, useTheme, useMediaQuery } from '@material-ui/core'
import Cookie from 'js-cookie'

import Navbar from './components/Navbar/Navbar'
import Footer from './components/Footer/Footer'
import ListMovies from './components/ListMovies/ListMovies'
import ListGames from './components/ListGames/ListGames'
import DetailMovie from './components/DetailMovie/DetailMovie'
import DetailGame from './components/DetailGame/DetailGame'
import LoginForm from './components/LoginForm/LoginForm'
import RegisterForm from './components/RegisterForm/RegisterForm'
import DrawerPermanent from './components/DrawerPermanent/DrawerPermanent'
import MoviesDatabase from './components/MoviesDatabase/MoviesDatabase'
import GamesDatabase from './components/GamesDatabase/GamesDatabase'
import Dashboard from './components/Dashboard/Dashboard'
import ChangePassword from './components/ChangePassword/ChangePassword'
import MoviesAdd from './components/MoviesAdd/MoviesAdd'
import MoviesEdit from './components/MoviesEdit/MoviesEdit'
import GamesAdd from './components/GamesAdd/GamesAdd'
import GamesEdit from './components/GamesEdit/GamesEdit'
import MobileAdminNavigation from './components/MobileAdminNavigation/MobileAdminNavigation'
import EmptyState from './components/EmptyState/EmptyState'
import { getGames, getMovies } from './api'
import { useStore } from './context/Context'

const TabChangerOnRefresh = ({ path }) => {
  const { setSelectedTab, setSelectedDrawer, isLogin } = useStore()
  const theme = useTheme()
  const matchSM = useMediaQuery(theme.breakpoints.down('sm'))

  useEffect(() => {
    const selectPath = () => {
      switch (path) {
        case '/':
          setSelectedTab(0)
          setSelectedDrawer(false)
          break

        case '/movies':
          setSelectedTab(1)
          setSelectedDrawer(false)
          break

        case '/games':
          setSelectedTab(2)
          setSelectedDrawer(false)
          break

        case '/dashboard':
          setSelectedTab(false)
          setSelectedDrawer(0)
          break

        case '/moviesDb':
          setSelectedTab(false)
          setSelectedDrawer(1)
          break

        case '/gamesDb':
          setSelectedTab(false)
          setSelectedDrawer(2)
          break

        case '/changePassword':
          setSelectedTab(false)
          setSelectedDrawer(3)
          break

        default:
          setSelectedTab(false)
          setSelectedDrawer(false)
          break
      }
    }

    selectPath()
  }, [path, setSelectedTab, setSelectedDrawer])

  return matchSM && isLogin ? <div /> : <Toolbar />
}

const App = () => {
  const token = Cookie.get('token')
  const {
    setListMovies,
    setListGames,
    setIsLoading,
    signUpMode,
    isLogin,
    setIsLogin,
    setMessage,
    message
  } = useStore()

  useEffect(() => {
    const checkLogin = async () => {
      if (token) {
        setIsLogin(true)
      }
    }

    checkLogin()
  }, [setIsLogin, token])

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const { data: dataMovies } = await getMovies()
        const { data: dataGames } = await getGames()
        setListMovies(dataMovies)
        setListGames(dataGames)
        setIsLoading(false)
      } catch (error) {
        console.log(error)
        setIsLoading(false)
        setMessage(state => ({
          ...state,
          msg: error.message,
          open: true,
          severty: 'error'
        }))
      }
    }

    fetchData()
  }, [isLogin, setIsLoading, setListGames, setListMovies, setMessage])

  const theme = useTheme()
  const matchSM = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Router>
      <Navbar />
      <div style={{ display: 'flex', flexDirection: matchSM ? 'column' : 'row' }}>
        {isLogin ? matchSM ? (
          <MobileAdminNavigation />
        ) : <DrawerPermanent /> : null}
        {signUpMode ? (
          <RegisterForm />
        ) : (
          <LoginForm />
        )}
        <div style={{ flexGrow: 1 }}>
          {message.severty === 'error' ? (
            <EmptyState text={message.msg} />
          ) : (
            <Switch>
              <Route exact path="/">
                <TabChangerOnRefresh path="/" />
                <ListMovies />
                <ListGames />
              </Route>
              <Route path="/dashboard">
                {token !== undefined ? (
                  <>
                    <TabChangerOnRefresh path="/dashboard" />
                    <Dashboard />
                  </>
                ) : (
                  <Redirect to="/" />
                )}
              </Route>
              <Route exact path="/moviesDb">
                {token !== undefined ? (
                  <>
                    <TabChangerOnRefresh path="/moviesDb" />
                    <MoviesDatabase />
                  </>
                ) : (
                  <Redirect to="/" />
                )}
                )}
              </Route>
              <Route path="/moviesDb/add">
                {token !== undefined ? (
                  <>
                    <TabChangerOnRefresh path="/moviesDb" />
                    <MoviesAdd />
                  </>
                ) : (
                  <Redirect to="/" />
                )}
              </Route>
              <Route path="/moviesDb/edit/:id">
                {token !== undefined ? (
                  <>
                    <TabChangerOnRefresh path="/moviesDb" />
                    <MoviesEdit />
                  </>
                ) : (
                  <Redirect to="/" />
                )}
              </Route>
              <Route exact path="/gamesDb">
                {token !== undefined ? (
                  <>
                    <TabChangerOnRefresh path="/gamesDb" />
                    <GamesDatabase />
                  </>
                ) : (
                  <Redirect to="/" />
                )}
              </Route>
              <Route path="/gamesDb/add">
                {token !== undefined ? (
                  <>
                    <TabChangerOnRefresh path="/gamesDb" />
                    <GamesAdd />
                  </>
                ) : (
                  <Redirect to="/" />
                )}
              </Route>
              <Route path="/gamesDb/edit/:id">
                {token !== undefined ? (
                  <>
                    <TabChangerOnRefresh path="/gamesDb" />
                    <GamesEdit />
                  </>
                ) : (
                  <Redirect to="/" />
                )}
              </Route>
              <Route path="/changePassword">
                {token !== undefined ? (
                  <>
                    <TabChangerOnRefresh path="/changePassword" />
                    <ChangePassword />
                  </>
                ) : (
                  <Redirect to="/" />
                )}
              </Route>
              <Route path="/movies">
                <TabChangerOnRefresh path="/movies" />
                <ListMovies />
              </Route>
              <Route path="/games">
                <TabChangerOnRefresh path="/games" />
                <ListGames />
              </Route>
              <Route path="/showMovie/:id">
                <TabChangerOnRefresh path="/detail" />
                <DetailMovie />
              </Route>
              <Route path="/showGame/:id">
                <TabChangerOnRefresh path="/detail" />
                <DetailGame />
              </Route>
              <Route>
                <TabChangerOnRefresh path="/detail" />
                <EmptyState text="Not Found 404" />
              </Route>
            </Switch>
          )}
          <Footer />
        </div>
      </div >
    </Router >
  )
}

export default App
